import { EffectType } from "../services/zodiacEngine/types";

export const actionableEffects: EffectType[] = [
  EffectType.entangle,
  EffectType.rotate,
];
